var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',_vm._g({staticClass:"diy-topbar__menu-item",attrs:{"target":_vm.isLink && '_blank'}},_vm.$listeners),[_c('AppIcon',{attrs:{"icon":_vm.icon}}),_c('span',{staticClass:"diy-topbar__menu-item-text"},[_vm._t("default"),(_vm.submenu)?_c('AppIcon',{attrs:{"icon":"fal fa-chevron-right"}}):_vm._e()],2),_vm._t("append-content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }